import { fromFeature } from "./feature.js";
import { parseGeometry, parseGC } from "./geometry.js";
import { buildHeader, deserialize as genericDeserialize, deserializeStream as genericDeserializeStream, deserializeFiltered as genericDeserializeFiltered, mapColumn } from "../generic/featurecollection.js";
import { buildFeature } from "../generic/feature.js";
import { magicbytes } from "../constants.js";
import { inferGeometryType } from "../generic/header.js";
export function serialize(featurecollection) {
    const headerMeta = introspectHeaderMeta(featurecollection);
    const header = buildHeader(headerMeta);
    const features = featurecollection.features.map((f) => buildFeature(f.geometry.type === 'GeometryCollection'
        ? parseGC(f.geometry)
        : parseGeometry(f.geometry), f.properties, headerMeta));
    const featuresLength = features.map((f) => f.length).reduce((a, b) => a + b);
    const uint8 = new Uint8Array(magicbytes.length + header.length + featuresLength);
    uint8.set(header, magicbytes.length);
    let offset = magicbytes.length + header.length;
    for (const feature of features) {
        uint8.set(feature, offset);
        offset += feature.length;
    }
    uint8.set(magicbytes);
    return uint8;
}
export function deserialize(bytes, headerMetaFn) {
    const features = genericDeserialize(bytes, fromFeature, headerMetaFn);
    return {
        type: 'FeatureCollection',
        features
    };
}
export function deserializeStream(stream, headerMetaFn) {
    return genericDeserializeStream(stream, fromFeature, headerMetaFn);
}
export function deserializeFiltered(url, rect, headerMetaFn) {
    return genericDeserializeFiltered(url, rect, fromFeature, headerMetaFn);
}
function introspectHeaderMeta(featurecollection) {
    const feature = featurecollection.features[0];
    const properties = feature.properties;
    let columns = null;
    if (properties)
        columns = Object.keys(properties).map((k) => mapColumn(properties, k));
    const geometryType = inferGeometryType(featurecollection.features);
    const headerMeta = {
        geometryType,
        columns,
        envelope: null,
        featuresCount: featurecollection.features.length,
        indexNodeSize: 0,
        crs: null,
        title: null,
        description: null,
        metadata: null
    };
    return headerMeta;
}
